const Snippets = {
  tags: function ({ id }: any) {
    if (!id) console.warn('GTM Id is required');

    const script1 = `window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${id}');`;

    return {
      script1,
    };
  },
};

export default Snippets;
